import styled from 'styled-components'

export const EmptyImg = styled.img`
    width: 45%;
`